export default {
  payload(state, getters) {
    return state.example;
  },
}